import React from 'react';


export default class Integrations extends React.Component {
  render (){
    const is_mobile = window.innerWidth < 1200;
    return (
      <section id="integrations" className="content-section flex-center text-center">
        <div className="container-fluid">

          <h4 className="text-primary">
            Out of box support for events triggered from
          </h4>

          <div className="row flex-center">
            <div className={(is_mobile)? ' col-12 ' : " col-8 "}>
              <img 
                className={" img img-fluid mw-100 text-center align-self-center "  + ((is_mobile)? 'my-1 ': "my-3")}
                src={"/static/images/integrations/processors.svg"} 
                style={{height: '100px'}}
                alt={"notification snapshot"} />
            </div>
          </div>

          <p className={(is_mobile)? 'my-1 ': "my-3"}>
            and more being worked on ...
          </p>

          <h4 className="text-primary mt-3">
            Get notifications sent to your chosen destinations
          </h4>

          <div className="row flex-center">
            <div className={(is_mobile)? ' col-12 ' : " col-8 "}>
              <img 
                className={" img img-fluid mw-100 text-center align-self-center "  + ((is_mobile)? 'my-1 ': "my-3")}
                src={"/static/images/integrations/deliveries.svg"} 
                style={{height: '100px'}}
                alt={"notification snapshot"} />
            </div>
          </div>

          <p className={(is_mobile)? 'my-1 ': "my-3"}>
            ... more in the works
          </p>

          <h4 className="text-primary mt-3">
            Without maintaining any code!
          </h4>


        <div className="my-5 p-0 bg-light  rounded border box-shadow ">
        <div className="row m-0 p-0 ">
          <div className="col-md-3">
          <img 
                className=" my-3 img img-fluid mw-100 text-center align-self-center " 
                src={"/static/ss/notifications/slack_bitbucket.png"} 
                alt={"notification snapshot"} />
          </div>
          <div className="col-md-3">
          <img 
                className=" my-3 img img-fluid mw-100 text-center align-self-center " 
                src={"/static/ss/notifications/slack_netlify.png"} 
                alt={"notification snapshot"} />
          </div>
          <div className="col-md-3">
          <img 
                className=" my-3 img img-fluid mw-100 text-center align-self-center " 
                src={"/static/ss/notifications/discord_heroku_release_create.png"} 
                alt={"notification snapshot"} />
          </div>
          <div className="col-md-3">
          <img 
                className=" my-3 img img-fluid mw-100 text-center align-self-center " 
                src={"/static/ss/notifications/discord_heroku_release_update.png"} 
                alt={"notification snapshot"} />
          </div>
        </div>
        </div>

        </div>
      </section>
    )
  }
}